/**
 * List all possible communication device types the system is capable of processing.
 */
export enum CommunicationDeviceName {
  softPhone = 'softPhone',
}

export type CommunicationDeviceNameType = keyof typeof CommunicationDeviceName;
